module.exports = __webpack_public_path__ + "images/store_case_study/article-pic1_f2a2a9db0b1a8d37844739c77f34878f.png";